export enum LeviBlackCardPosition {
  TopRight = 'top-right',
  Middle = 'middle',
}
